

<template>
  <div class="questionentry">
    <el-form :model="param" :rules="rules" ref="param" label-width="100px" style="width: 600px">
      <el-form-item label="所属课程" prop="courseId" >
        <el-select v-model="param.courseId" clearable filterable placeholder="请选择" @change="param.chapterId=''" style="width:260px">
          <el-option
              v-for="item in CourselistData"
              :key="item.courseId"
              :label="item.courseName"
              :value="item.courseId">
          </el-option>
        </el-select>
      </el-form-item>
      
      <el-form-item label="所属章节" prop="chapterId">
        <el-select v-model="param.chapterId" filterable placeholder="请选择" style="width:260px;margin-right: 20px;">
          <el-option
              v-for="item in chapterlistData"
              :key="item.chapterId"
              :label="item.chapterName"
              :value="item.chapterId">
          </el-option>
        </el-select>
        <el-button type="primary" @click="ADDchapter">新增章节</el-button>
      </el-form-item>

      <el-form-item label="题目类型" prop="examtype">
        <el-radio-group v-model="param.examtype">
          <el-radio label="1">选择题</el-radio>
          <el-radio label="4">问答题</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="题目" prop="questionTitle" >
        <el-input type="textarea" v-model="param.questionTitle" maxlength="500" show-word-limit></el-input>
      </el-form-item>

      <el-form-item label="序号" style="width: 360px">
        <el-input type="text" v-model.number="param.questionCode" disabled maxlength="5" show-word-limit></el-input>
      </el-form-item>

      <div v-if="param.examtype==1">
        <el-form-item label="常用选项" prop="topic">
          <el-col>
            <el-popover
                placement="right"
                width="600"
                v-model="visible"
                trigger="click">
              <p style="font-weight: bold;font-size: 16px;padding: 10px 0;">以下为常用选项，可直接加入：</p>
              <div class="changyong">
                <ul class="changyonglist">
                  <li v-for="item in Commonitems">
                    <div class="itemlist">
                      <div v-for="data in item.answerVOS">{{ data.option }}</div>
                    </div>
                    <div><span @click="Clickjoinanswer(item.answerVOS)">加入</span><span @click="DeleteCommonites(item)">删除</span></div>
                  </li>
                </ul>
                <el-pagination
                  @current-change="handleCommonitemsChange"
                  hide-on-single-page
                  layout="prev, pager, next"
                  :current-page.sync="Commonlyparams.pageNum"
                  :page-size="Commonlyparams.pageSize"
                  :total="Commonlyparams.total">
                </el-pagination>
              </div>
              <div style="margin: 30px 0 0">
                <el-button @click="visible = !visible">取消</el-button>
              </div>
              <el-button slot="reference" type="primary">使用常用选项</el-button>
            </el-popover>
            <el-button style="margin-left: 10px" type="primary" @click="ADDcurrentCommon">将当前选项加入常用选项</el-button>
          </el-col>
        </el-form-item>

        <el-form-item label="选项类型" prop="alternativestype" style="width: 360px">
          <el-select v-model="param.alternativestype" placeholder="请选择" @change="changealternativestype" style="width:260px">
            <el-option
                v-for="item in alternatives"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item 
          style="width: 650px;"
          v-for="(item,index) in param.answers" 
          :label="'选项'+String.fromCharCode(65 + index)"
          :prop="'answers.'+index+'.option'"
          :rules="[{ required: true, message: '请输入选项', trigger: ['change','blue'] }]"
          >
          <el-input v-if="item.optionType==1" type="textarea"  v-model="item.option" style="width:260px;" maxlength="300" show-word-limit></el-input>
          <img :src="item.option" v-if="item.optionType==2 && item.option!=''" style="width: 180px;height: 180px;">
          <div style="width: 180px;height: 180px;background: #f5f5f5;display:inline-block;" v-if="item.optionType==2 && item.option==''"></div>
          <el-upload
              v-if="item.optionType==2"
              class="upload-topic"
              :action="actionUrl"
              :headers="{Authorization:Authorization}"
              name="images"
              accept="image/jpeg,image/gif,image/png"
              :before-upload="(value)=>handbeforeupload(index,value)"
              :on-success="(value)=> handsuccess(index, value)"
              :show-file-list="false"
          >
          <el-button type="primary">上传图片</el-button>
          </el-upload>
          <div style="margin-left: 10px;display: inline-block;">
            <el-button  v-if="param.answers.length-1==index" type="primary" @click="ADDanswers">添加选项</el-button>
            <el-button @click="DeleteAnswers(index)">删除选项</el-button>
          </div>
        </el-form-item>


        <el-form-item label="答案" v-show="param.answers.length>0" prop="answer" :rules="[{ required: true, message: '请选择答案', trigger: 'change' }]">
          <el-select v-model="param.answer" multiple clearable placeholder="请选择" style="width:260px">
            <el-option
                v-for="(item,index) in param.answers"
                :key="String.fromCharCode(65 + index)"
                :label="String.fromCharCode(65 + index)"
                :value="String.fromCharCode(65 + index)">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="标签" >
          <el-input type="text" v-model="param.questionTag" style="width:260px;" maxlength="200" show-word-limit></el-input>
          <!-- <p style="font-size: 12px;color: #333;">说明：标签可作为查询课程的条件，多个标签需用“,”分隔。</p> -->
        </el-form-item>
      </div>

      <!-- 问答 -->
      <div v-else>
        <el-form-item label="参考答案" >
          <el-input type="textarea" class="textarea" v-model="textarea" style="width:400px;" maxlength="2000" show-word-limit></el-input>
        </el-form-item>
      </div>

      <el-form-item>
        <!-- <el-button type="primary" @click="">上一题</el-button>
        <el-button type="primary" @click="resetForm('param')">下一题</el-button> -->
        <el-button type="primary" @click="submitForm('param')" :loading="iscontinuous">提交</el-button>
        <el-button @click="TabCloseCurrent">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default{
  name:'questionentry',
  data(){
    return{
      iscontinuous:false,
      editableTabs: sessionStorage.getItem('OpenTabs') && sessionStorage.getItem('OpenTabs') != '' ? JSON.parse(sessionStorage.getItem('OpenTabs')) : [ sessionStorage.getItem('entity') == '管理员' ? { title: '工作台', name: 'Set_basis', path: '/Set/Set_basis',} : sessionStorage.getItem('entity') == '咨询师' ? { title: '工作台',  name: 'ConsultantWork', path: '/Consultant/ConsultantWork', } : { title: '首页', name: 'index',  path: '/index', },],
      actionUrl:process.env.VUE_APP_URL+'AppUser/UpdatePortraitAndCertificate',
      Authorization:sessionStorage.getItem('Authorization'),
      rules:{
        courseId:[{required: true, message: '请选择所属课程', trigger: 'change'}],
        chapterId:[{required: true, message: '请选择所属章节', trigger: 'change'}],
        examtype:[{required:true,message:'请选择题目类型',trigger:'change'}],
        questionTitle:[{required: true, message: '请输入题目', trigger: 'blur'}],
        alternativestype:[{required:true,message:'请选择选项类型',trigger:'change'}],
      },
      param:{
        questionId:'',
        questionCode:'',
        courseId:'',
        chapterId:'',
        questionType:'',
        examtype:"1",
        questionTitle:'',
        questionTag:'',
        commonOption:'',
        alternativestype:'',
        answer:[],
        answers:[
          {optionType:1,option:'',answer:0,answerOrder:'A'},
          {optionType:1,option:'',answer:0,answerOrder:'B'},
          {optionType:1,option:'',answer:0,answerOrder:'C'},
          {optionType:1,option:'',answer:0,answerOrder:'D'}
        ]
      },
      textarea:'',
      visible:false ,
      Commonitems:[],//常用项
      CourselistData:[],
      chapterlistData:[],
      // 课程选项
      CourseParam:{
        courseId:'',
        pageNum:1,
        pageSize:20,
        courseName:''
      },
      Commonlyparams:{
        pageNum:1,
        pageSize:10,
        total:0
      },
      // 章节

      alternatives:[{value: '1',label: '文字'}, {value: '2',label: '图片'}],
    }
  },
  watch:{
    'param.courseId'(newval,oldval){
      if(this.param.courseId==''){
        this.CourseParam.courseId='';
        this.chapterlistData=[];
      }else{
        this.CourseParam.courseId=newval;
        this.Getchapter();
      }
      this.Courselist();
    },
    'param.alternativestype'(newval,oldval){
      if(this.param.alternativestype==2){
        for(let item of this.param.answers){
          item['optionType']=2;
        }
      }else{
        for(let item of this.param.answers){
          item['optionType']=1;
        }
      }
    },
    'param.answer'(newval,oldval){
      for(var i=0;i<this.param.answers.length;i++){
        this.param.answers[i].answerOrder=this.param.answers[i].answerOrder==null?String.fromCharCode(65 + i):this.param.answers[i].answerOrder
        for(let item of newval){
          if(this.param.answers[i].answerOrder==item){
            this.param.answers[i].answer=1;
            break;
          }else{
            this.param.answers[i].answer=0;
          }
        }
      }
      
    }
  },
  created() {
    this.param.questionId=this.$route.query.questionId;
    this.Courselist();
    if(this.param.questionId){
      this.getInfoDetail();
    }else{
      this.QuestionCode();
    }
    this.getCommonlyUsed();
  },
  methods:{
    // 获取详情数据
    getInfoDetail(){
      this.$Http_Get('edu/question/getInfo/'+this.param.questionId).then(res=>{
        if(res.Code==0){
          this.param.answers=res.Data.answers;
          this.param.chapterId=res.Data.chapterId;
          this.param.courseId=res.Data.courseId;
          this.textarea=res.Data.questionType==4?res.Data.answers[0].option:'';
          this.param.chapterName=res.Data.chapterName;
          this.param.questionCode= res.Data.questionCode;
          this.param.questionTag= res.Data.questionTag;
          this.param.questionTitle= res.Data.questionTitle;
          this.param.examtype=res.Data.questionType==4?res.Data.questionType.toString():"1";
          this.param.alternativestype=res.Data.answers[0].optionType.toString();
          for(var i=0;i<res.Data.answers.length;i++){
            if(res.Data.answers[i].answer==1){
              this.param.answer.push(String.fromCharCode(65 + i));
            }
          }
        }else{
          this.$message({type: 'error', message:'查询详情数据失败'});
        }
      });
    },

    // 新增章节
    ADDchapter(){
      if(this.param.courseId==''){
        this.$message({type: 'error', message:'请先选择课程'});
        return false
      }
      this.$router.push('addcourse?isNew=0&courseId='+this.param.courseId)
    },

    // 获取常用项
    getCommonlyUsed(){
      this.$Http_Post('edu/question/getCommonlyUsed',this.Commonlyparams).then(res=>{
        if(res.Code==0){
          this.Commonitems=res.Data;
          this.Commonlyparams.total=res.Counts;
        }else{
          this.$message({type: 'error', message:'获取常用项失败'});
        }
      });
    },
    // 获取序号
    QuestionCode(){
      this.$Http_Get('edu/question/getQuestionCode').then(res=>{
        if(res.Code==0){
          this.param.questionCode=res.Data;
        }else{
          this.$message({type: 'error', message: res.Message});
        }
      });
    },
    // 获取课程列表
    Courselist(){
      this.$Http_Post('edu/course/list',this.CourseParam).then(res=>{
        if(res.Code==0){
          this.CourselistData=res.Data;
        }
      })
    },
    // 获取章节
    Getchapter(){
      this.$Http_Post('edu/chapter/list',this.CourseParam).then(res=>{
        if(res.Code==0){
          this.chapterlistData=res.Data;
        }
      })
    },

    // 添加一项选项
    ADDanswers(){
      if(this.param.answers[this.param.answers.length-1].option==""){
        this.$message({type: 'error', message:"请填写选项答案后在继续添加选项"});
        return false;
      };
      let str={
        optionType:this.param.alternativestype==''?1:this.param.alternativestype,option:'',answer:0,id:this.param.answers.length,answerOrder:String.fromCharCode(65 + this.param.answers.length)
      }
      this.param.answers.push(str);
    },

    // 删除当前项
    DeleteAnswers(val){
      if(this.param.answers.length<=2){
        this.$message({type: 'error', message: "选项不能少于两个"});
        return false;
      }else{
        this.param.answer=[];
        this.param.answers.splice(val,1);
        for(var i=0;i<this.param.answers.length;i++){
          this.param.answers[i].answerOrder=String.fromCharCode(65 + i);
        }
      }
    },
    // 上传前
    handbeforeupload(index,file){
      if (file.type == 'image/jpg' || file.type == 'image/jpeg' || file.type == 'image/png') {
        // this.trainload=true;
      }else{
        this.$message({type: 'error', message:"请上传正确的图片格式"});
        return false;
      }
    },
    // 上传图片
    handsuccess(e,fileList,index,data){
      this.param.answers[e].option=fileList.Data;
    },
    // 选项类型
    changealternativestype(val){
      this.param.answer=[];
      this.param.answers=this.$options.data().param.answers
    },
    // 提交
    submitForm(formName) {
      this.param.questionType=this.param.examtype==4?'4':this.param.answer.length>1?'2':'1';
      if(this.param.questionType==4){
        this.param['answers']=[{optionType:'1',option:this.textarea,answer:1}]
      }
      this.$refs[formName].validate((valid) => {
          if (valid) {
            this.iscontinuous = true
            if(this.param.questionId){
              this.$Http_Post('edu/question/edit',this.param).then(res=>{
              if(res.Code==0){
                this.iscontinuous = false
                this.$message({type: 'success', message:"修改成功"});
              }else{
                this.iscontinuous = false
                this.$message({type: 'error', message:"修改失败"});
              }
            })
            }else{
              this.$Http_Post('edu/question/add',this.param).then(res=>{
                if(res.Code==0){
                  this.iscontinuous = false
                  this.$message({type: 'success', message:res.Message});
                  this.$refs[formName].resetFields();
                  this.param.questionTag='';
                  this.QuestionCode();
                }else{
                  this.iscontinuous = false
                  this.$message({type: 'error', message:res.Message});
                }
              })
            }
          } else {
            this.$message({type: 'error', message: "请填写完整信息"});
            return false;
          }
        });
    },

    // 下一题重置
    resetForm(formName){
      this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$refs[formName].resetFields();
            this.param.questionTag='';
            this.QuestionCode();
          }else{
            this.$message({type: 'error', message: "请填写完整信息"});
            return false;
          }
        })

      
    },
    // 关闭当前页面
    TabCloseCurrent() {
      let closeIndex='';
      for(var i=0;i<this.editableTabs.length;i++){
        if(this.editableTabs[i].name=='questionentry'){
          closeIndex=i;
        }
      }
      this.editableTabs.splice(closeIndex, 1);
      sessionStorage.setItem('OpenTabs', JSON.stringify(this.editableTabs));
      this.$router.push(this.editableTabs[this.editableTabs.length - 1].path);
    },

    // 删除常用项
    DeleteCommonites(e){
      this.$Http_Post('edu/question/remove/'+e.questionId).then(res=>{
        if(res.Code==0){
          this.$message({type: 'success', message: "删除成功"});
          this.getCommonlyUsed();
        }else{
          this.$message({type: 'error', message: "删除失败"});
        }
      })
    },
    // 添加答案
    Clickjoinanswer(e){
      this.param.answers=e;
      this.param.answer=[];
      for(let item of e){
        if(item.answer==1){
          this.param.answer.push(item.answerOrder);
        }
      }
    },

    // 添加当前常用项目
    ADDcurrentCommon(){
      let a=this.param.answers;
      if(this.param.answer.length==0){
        this.$message({type: 'warning', message: "添加答案后才可添加为常用项"});
        return false
      }else{
        for(let item of this.param.answers){
          if(item.option==''){
            this.$message({type: 'warning', message: "请添加选项"});
            return;
          }
        }
      }
      this.$Http_Post('edu/question/addCommonlyUsed',{answers:this.param.answers}).then(res=>{
        if(res.Code==0){
          this.$message({type: 'success', message: "常用项添加成功"});
          this.getCommonlyUsed();
        }else{
          this.$message({type: 'error', message: "添加失败"});
        }
      });
    },
    // 常用项分页
    handleCommonitemsChange(val){
      this.Commonlyparams.pageNum=val;
      this.getCommonlyUsed();
    }
  }
}
</script>
<style>
body{overflow: hidden;}
.questionentry{background: #fff;padding:30px;}
.changyong .changyonglist li{padding:10px;border-bottom:dashed 1px #dedede;position: relative;}
.changyong .changyonglist li .itemlist{width:90%;}
.changyong .changyonglist li .itemlist div{padding:5px 10px;width: 20%;display:inline-block;}
.changyong .changyonglist li>div:last-child{position: absolute;right: 0;top:50%;transform: translate(0,-50%);}
.changyong .changyonglist li>div:last-child span{padding:0 5px;cursor: pointer;}
.questionentry .upload-topic{display: inline-block;margin-left: 10px}
.questionentry .textarea textarea{min-height:400px;}
</style>